export default function Benefits() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4">
            Dlaczego Kakobuy Spreadsheet
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Dlaczego tysiące użytkowników szuka{' '}
            <span className="italic text-primary-500">Kakobuy Spreadsheet</span>?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-16">
          {[
            {
              icon: "ri-search-eye-line",
              title: "Szybkie wyszukiwanie produktów",
              desc: "Znajdź interesujące Cię produkty w kilka sekund dzięki uporządkowanej strukturze arkusza Kakobuy.",
            },
            {
              icon: "ri-scales-3-line",
              title: "Porównanie najlepszych ofert",
              desc: "Porównuj ceny i jakość produktów z różnych kategorii, aby podejmować najlepsze decyzje zakupowe.",
            },
            {
              icon: "ri-file-list-3-line",
              title: "Gotowe listy zakupowe",
              desc: "Korzystaj z gotowych, regularnie aktualizowanych list produktów przygotowanych przez ekspertów Kakobuy.",
            },
            {
              icon: "ri-refresh-line",
              title: "Regularnie aktualizowane",
              desc: "Wszystkie dane w Kakobuy Spreadsheet są na bieżąco aktualizowane, abyś zawsze miał dostęp do najnowszych informacji.",
            },
          ].map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-2xl p-6 border border-background-200/60 text-center group hover:border-accent-300 transition-colors">
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-background-200/60">
                  <th className="text-left px-6 py-4 font-semibold text-foreground-900">Funkcja</th>
                  <th className="text-center px-6 py-4 font-semibold text-primary-600">
                    Kakobuy Spreadsheet
                  </th>
                  <th className="text-center px-6 py-4 font-semibold text-foreground-500">
                    Standardowe wyszukiwanie
                  </th>
                </tr>
              </thead>
              <tbody>
                {[
                  { feature: "Organizacja produktów", kakobuy: true, standard: false },
                  { feature: "Lista linków", kakobuy: true, standard: false },
                  { feature: "Porównanie kategorii", kakobuy: true, standard: "Ograniczone" },
                  { feature: "Oszczędność czasu", kakobuy: "Wysoka", standard: "Niska" },
                  { feature: "Aktualizacje", kakobuy: "Regularne", standard: "Brak" },
                ].map((row, idx) => (
                  <tr key={idx} className="border-b border-background-200/40 last:border-0">
                    <td className="px-6 py-3.5 text-foreground-800">{row.feature}</td>
                    <td className="px-6 py-3.5 text-center">
                      {typeof row.kakobuy === 'boolean' ? (
                        row.kakobuy ? (
                          <i className="ri-check-line text-accent-500 text-lg"></i>
                        ) : (
                          <i className="ri-close-line text-foreground-300 text-lg"></i>
                        )
                      ) : (
                        <span className="text-accent-600 font-medium text-xs">{row.kakobuy}</span>
                      )}
                    </td>
                    <td className="px-6 py-3.5 text-center">
                      {typeof row.standard === 'boolean' ? (
                        row.standard ? (
                          <i className="ri-check-line text-accent-500 text-lg"></i>
                        ) : (
                          <i className="ri-close-line text-foreground-300 text-lg"></i>
                        )
                      ) : (
                        <span className="text-foreground-500 text-xs">{row.standard}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}